import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface NavVisibilitySliceState {
  /** Whether the sticky header + mobile bottom nav are currently shown (they hide on scroll-down). */
  isNavVisible: boolean;
}

const initialState: NavVisibilitySliceState = {
  isNavVisible: true,
};

export const navVisibilitySlice = createSlice({
  name: "navVisibilitySlice",
  initialState,
  reducers: {
    setNavVisible: (state, action: PayloadAction<boolean>) => {
      state.isNavVisible = action.payload;
    },
  },
});

export const { setNavVisible } = navVisibilitySlice.actions;
export default navVisibilitySlice;
